Namespace 'Customer.Filters'

class Customer.Filters.EditFilterUsersTabView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/edit_filter_users_tab']
  className: 'filter-field-container filter-users-container'

  initialize: ({users}) ->
    @users = users

  render: ->
    @$el.html @template
      users: @users.join(', ')
    @
